import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-side-list',
  templateUrl: './side-list.component.html',
  styleUrls: ['./side-list.component.css']
})
export class SideListComponent implements OnInit {

  searchText:string='';
  @Input() itemList:any[];
  @Input() showItem:string;
  @Input() searchItem:string;
  @Input() showColor:boolean=false;
  @Input() showDelete:boolean=true;
  @Input() enableDrag:boolean=false;
  @Output() selectedObject= new EventEmitter<any>();
  @Output() deleteObject= new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }
  getSingle(obj:any)
  {
      this.selectedObject.emit(obj);
  }
  deleteDtl(obj:any)
  {
      this.deleteObject.emit(obj);
  }
  
}
